<template>
    <div v-if="text" class="indications-container">
        <div :class="['font-italic', { 'indications-truncated': !showFullText }]" v-html="text" ref="textElement"></div>
        <v-btn v-if="textNeedsTruncation" @click="toggleText" variant="text" size="small" color="darkblue"
            class="mt-1 pa-0">
            {{ showFullText ? 'Afficher moins' : 'Afficher plus' }}
            <v-icon :icon="showFullText ? 'mdi-chevron-up' : 'mdi-chevron-down'" class="ml-1"></v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'CourseInformationsTruncated',
    props: {
        text: {
            type: String,
            default: ''
        },
        maxLines: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            showFullText: false,
            textNeedsTruncation: false
        };
    },
    methods: {
        toggleText() {
            if (this.showFullText) {
                // Réduction du texte avec animation
                this.animateTextCollapse();
            } else {
                // Expansion du texte avec animation
                this.animateTextExpand();
            }
            this.showFullText = !this.showFullText;
        },

        animateTextExpand() {
            const element = this.$refs.textElement;
            if (element) {
                element.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
                element.style.maxHeight = '1000px';
            }
        },

        animateTextCollapse() {
            const element = this.$refs.textElement;
            if (element) {
                element.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
                element.style.maxHeight = 'calc(1.4em * 3)';
            }
        },
        checkTextTruncation() {
            this.$nextTick(() => {
                if (this.$refs.textElement) {
                    const element = this.$refs.textElement;
                    const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
                    const maxHeight = lineHeight * this.maxLines;
                    this.textNeedsTruncation = element.scrollHeight > maxHeight;
                }
            });
        }
    },
    mounted() {
        this.checkTextTruncation();
    },
    updated() {
        this.checkTextTruncation();
    },
    watch: {
        text() {
            this.checkTextTruncation();
        }
    }
};
</script>

<style lang="scss" scoped>
.indications-container {
    .indications-truncated {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: all 0.3s ease-in-out;
        max-height: calc(1.4em * 3);
    }

    // Animation pour l'expansion/réduction du texte
    .font-italic {
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden;

        &:not(.indications-truncated) {
            max-height: none;
            animation: expandText 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }
    }
}

// Animation d'expansion du texte
@keyframes expandText {
    from {
        max-height: calc(1.4em * 3);
        opacity: 0.8;
    }

    to {
        max-height: 1000px; // Valeur suffisamment grande pour contenir tout le texte
        opacity: 1;
    }
}

// Animation de réduction du texte
@keyframes collapseText {
    from {
        max-height: 1000px;
        opacity: 1;
    }

    to {
        max-height: calc(1.4em * 3);
        opacity: 0.8;
    }
}
</style>